import { AxiosResponse } from 'axios';
import { apiCall, clearCachedGetRequests } from './BaseAction';
import {
  EquipmentCategories,
  EquipmentImageUpload,
  EquipmentItem,
  EquipmentList,
  FilterEquipmentList,
  TApiEntityImage,
  TApiEquipmentCategory,
  TApiEquipmentEntity,
  TFilterEquipmentListAction,
  TGetEquipmentCategories,
  TGetEquipmentItem,
  TGetEquipmentList,
  TUploadEquipmentImage,
} from '../types/Equipment';
import { Dispatch } from 'redux';
import { TDispatch } from '../types/Thunk';

export const getEquipmentCategories = () => {
  return apiCall<TGetEquipmentCategories, null, Array<TApiEquipmentCategory>>(
    EquipmentCategories,
    'GET',
    '/equipment/categories',
    true
  );
};

export const getEquipmentList = (categoryId?: number) => {
  return apiCall<TGetEquipmentList, null, Array<TApiEquipmentEntity>>(
    EquipmentList,
    'GET',
    '/equipment',
    true,
    null,
    { category: categoryId }
  );
};

export const getEquipment = (equipmentId: number) => {
  return apiCall<TGetEquipmentItem, null, TApiEquipmentEntity>(
    EquipmentItem,
    'GET',
    `/equipment/${equipmentId}`,
    true
  );
};

export const uploadEquipmentImage = (equipmentId: number, image: string) => {
  return async (
    dispatch: TDispatch<TUploadEquipmentImage>
  ): Promise<AxiosResponse<TApiEntityImage>> => {
    const response = await apiCall<
      TUploadEquipmentImage,
      { image: string },
      TApiEntityImage
    >(
      EquipmentImageUpload,
      'POST',
      `/equipment/${equipmentId}/image`,
      true,
      { image }
    )(dispatch);

    await clearCachedGetRequests();

    return response;
  };
};

export const filterEquipmentList = (search: string, location?: string) => {
  return (dispatch: Dispatch<TFilterEquipmentListAction>) => {
    dispatch({
      type: FilterEquipmentList.SUBMIT,
      payload: { search, location },
    });
  };
};
